import { render, staticRenderFns } from "./HistoryAction.vue?vue&type=template&id=53d54d4b&scoped=true&"
import script from "./HistoryAction.vue?vue&type=script&lang=js&"
export * from "./HistoryAction.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAction.vue?vue&type=style&index=0&id=53d54d4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d54d4b",
  null
  
)

export default component.exports